import { Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { SpinnerService } from '../../services/spinner.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [AsyncPipe]
})
export class SpinnerComponent {
    private readonly spinnerService = inject(SpinnerService);
    isLoading$ = this.spinnerService.isLoading;

	constructor() {}
}
